var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { Component, Vue, Watch, Prop } from "vue-facing-decorator";
import { Feature, EventsClient, CompaniesClient, SitesClient, SortDescription, SortDirection, ReportScheduleModel, SystemAccessQueryModel, SystemsClient, GetChargeCycleSnapshotListPaginatedQuery, PaginatedEnumerableOfChargeCycleSnapshotModel, StringStatusEnum, GetDischargeDetailsQuery, DischargeClient, GetChargeCycleEventsForSnapshotQuery } from "@/app/api/battery-portal-api";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { Notifier } from "@//common/utils/notifier";
import { DatePresetOption } from "@/common/enums/date-preset";
import { LoginState } from "@/app/store/modules/login.state";
import { State } from "vuex-facing-decorator";
import moment from "moment";
import SelectableListOption from "@/common/utils/selectable-list-option";
import Toggle from '@vueform/toggle';
import { defineAsyncComponent } from "vue";
// Eagerly start fetching the charts chunk at module load so it is available by the time chart data is populated.
const dischargeReportFilterGraphPromise = import(/* webpackChunkName: "charts" */ "@/app/vues/charts/discharge-report-filter-graph.vue");
const DischargeReportFilterGraphVue = defineAsyncComponent(() => dischargeReportFilterGraphPromise);
import store from "@/app/store/store";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const systemsClient = new SystemsClient(window.apiUrl);
const eventsClient = new EventsClient(window.apiUrl);
const dischargesClient = new DischargeClient(window.apiUrl);
let DischargeReportFilterVue = class DischargeReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.reportScheduleQueryLoaded = false;
        this.componentKey = 0;
        this.working = false;
        this.searchAttempted = false;
        this.useImperialMeasurementSystem = store.getters["loginModule/isUsingImperialMeasurementSystem"];
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        this.dateFilterOptions = ["W", "M", "3M", "Y", "..."];
        this.dateFilterOption = "";
        this.defaultDateFilterOption = "3M";
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SnapshotDate",
            direction: SortDirection.Descending
        }));
        this.companies = [];
        this.sites = [];
        this.companyId = null;
        this.siteId = null;
        this.selectedSystem = new SystemAccessQueryModel();
        this.systems = new Array();
        this.automaticDuration = true;
        this.displayChart = false;
        this.startTime = new Date();
        this.endTime = new Date();
        this.selectedChargeCycleSnapshot = null;
        this.chargeCycleSnapshotsQuery = new GetChargeCycleSnapshotListPaginatedQuery({
            pageNo: 1,
            pageSize: 15,
            systemId: 0,
            companyId: 0,
            includeSnapshotsWithoutMeasurements: false,
            onlyDischargeEvents: true,
            startTime: null,
            endTime: null
        });
        this.chargeCycleSnapshots = new PaginatedEnumerableOfChargeCycleSnapshotModel();
        this.stringsList = new Array();
        this.eventsDateTimeList = new Array();
        this.startEventDate = new Date();
        this.endEventDate = new Date();
        this.overrideLimits = false;
        this.blockVoltageLowLimit = null;
        this.blockTemperatureHighLimit = null;
        this.chartData = {
            labels: [],
            datasets: []
        };
        this.displayUnit = "second";
        this.timeDisplayFormat = "HH:mm:ss";
        this.chartOptions = {
            fill: false,
            maintainAspectRatio: false,
            throttle: 100,
            showMarkers: false,
            animation: {
                duration: 0
            },
            onClick: this.onCurrentChartClick,
            scales: {
                y: {
                    id: "y-left",
                    type: "linear",
                    position: "left",
                    scaleLabel: {
                        display: true,
                        labelString: "Current (A)"
                    },
                    gridLines: {
                        drawBorder: false
                    }
                },
                x: {
                    id: "x-axis-0",
                    type: "time",
                    bounds: "ticks",
                    time: {
                        unit: this.displayUnit,
                        displayFormats: {
                            day: this.timeDisplayFormat,
                            hour: this.timeDisplayFormat,
                            minute: this.timeDisplayFormat,
                            second: this.timeDisplayFormat
                        }
                    },
                    gridLines: {
                        drawBorder: false
                    },
                    ticks: {
                        autoSkip: true,
                        maxTicksLimit: 24, // There are 24 vertical lines on the chart, one tick (label) under each vertical line
                        maxRotation: 45,
                        minRotation: 45
                    }
                }
            },
            plugins: {
                annotation: {
                    annotations: [
                        {
                            type: 'line',
                            borderColor: '#ff0000',
                            borderWidth: 2,
                            value: null,
                            scaleID: 'x',
                            label: {
                                display: true,
                                content: 'Start',
                                position: 'start',
                                xAdjust: -21
                            }
                        },
                        {
                            type: 'line',
                            borderColor: '#0000ff',
                            borderWidth: 2,
                            value: null,
                            scaleID: 'x',
                            label: {
                                display: true,
                                content: 'End',
                                position: 'start',
                                xAdjust: 19
                            }
                        }
                    ]
                }
            }
        };
        this.isEnd = false;
        this.isGraphClickEnd = false;
    }
    created() {
        this.getLookups();
        if (this.loginState.isPowerShield) {
            this.dateFilterOptions = ["Prev M", ...this.dateFilterOptions];
            this.defaultDateFilterOption = "Prev M";
        }
        this.dateFilterOption = this.defaultDateFilterOption;
        window.addEventListener("resize", this.windowResizedEventHandler);
    }
    ;
    mounted() {
        this.calculateGridHeight();
    }
    unmounted() {
        window.removeEventListener("resize", this.windowResizedEventHandler);
    }
    windowResizedEventHandler() {
        let timer = null;
        if (timer)
            window.clearTimeout(timer);
        timer = window.setTimeout(this.forceRerender, 100);
    }
    ;
    /**
    * Retrieve all lookups used by the form.
    * */
    getLookups() {
        return __awaiter(this, void 0, void 0, function* () {
            let promises = [
                systemsClient
                    .getSystems(false, Feature.Report_DischargeDetailed)
                    .then(response => {
                    if (!response)
                        return;
                    // The placeholder is not an option: a filter always needs a real system (CLD-1300)
                    this.systems = response;
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }),
                companyClient
                    .getListGET()
                    .then(response => {
                    let companies = (response || []).map((item) => {
                        return {
                            value: item.companyId,
                            text: item.companyName || ""
                        };
                    });
                    this.companies = [{ value: null, text: `All companies` }].concat(companies);
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
                    .finally(() => {
                }),
                siteClient
                    .getListForUser()
                    .then(response => {
                    this.sites = response;
                })
            ];
            return yield Promise.all(promises).then(() => {
                if (this.reportScheduledModel)
                    this.loadReportScheduleQuery(false, false);
            });
        });
    }
    ;
    getChargeCycleSnapshots() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (this.working)
                return;
            if (!this.selectedSystem || !this.selectedSystem.systemId)
                return;
            if (!DateHelper.validateDateRange((_a = this.startTime) !== null && _a !== void 0 ? _a : null, (_b = this.endTime) !== null && _b !== void 0 ? _b : null)) {
                Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
                return;
            }
            if (this.startDateInvalid || this.endDateInvalid) {
                Notifier.onWarning(`Please enter valid dates.`);
                return;
            }
            this.working = true;
            let query = this.chargeCycleSnapshotsQuery;
            this.chargeCycleSnapshotsQuery.systemId = this.selectedSystem.systemId;
            query.companyId = this.selectedSystem.companyId;
            query.startTime = this.startTime ? DateHelper.convertToDate(this.startTime.toString()) : null;
            query.endTime = this.endTime ? DateHelper.convertToDate(this.endTime.toString()) : null;
            return yield eventsClient
                .searchChargeCycleSnapshots(query)
                .then(response => {
                if (!response)
                    return;
                this.chargeCycleSnapshots = response;
                this.chargeCycleSnapshotsQuery.pageNo = response.displayedPage;
                this.chargeCycleSnapshotsQuery.pageSize = response.pageSize;
                this.selectedChargeCycleSnapshot = null;
                this.loadReportScheduleQuery(true, false);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    getChargeCycleMeasurementDates() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.selectChargeCycleSnapshot) {
                return;
            }
        });
    }
    setDateFilterOption(option) {
        this.dateFilterOption = option;
    }
    ;
    resetDateFilterOption() {
        this.dateFilterOption = this.defaultDateFilterOption;
    }
    ;
    selectChargeCycleSnapshot(item) {
        this.selectedChargeCycleSnapshot = item;
    }
    ;
    getChargeCycleSnapshotClass(snapshot) {
        var _a;
        return ((_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.snapshotId) == snapshot.snapshotId ? "selected" : "";
    }
    ;
    snapshotTypeString(snapshot) {
        if (snapshot.stringStatusId == StringStatusEnum.Charge)
            return "fa fa-arrow-up";
        if (snapshot.stringStatusId == StringStatusEnum.Discharge)
            return "fa fa-arrow-down";
        return "";
    }
    ;
    snapshotTypeDescriptionString(snapshot) {
        if (snapshot.stringStatusId == StringStatusEnum.Charge)
            return "Charge";
        if (snapshot.stringStatusId == StringStatusEnum.Discharge)
            return "Discharge";
        return "";
    }
    ;
    snapshotDateString(snapshot) {
        return DateHelper.convertToFriendlyMomentTimeString(snapshot.whenEventStarted);
    }
    ;
    componentNamesString(snapshot) {
        var name = snapshot.componentNames || "";
        return name
            .replace(/;/g, ", ");
    }
    ;
    getQuery() {
        var _a, _b;
        this.searchAttempted = true;
        if (this.isChargeCycleSnapshotInvalid) {
            Notifier.onWarning("Select a Discharge Event for the report!");
            return null;
        }
        if (this.working || this.isChargeCycleSnapshotInvalid || this.isBlockVoltageLowLimitInvalid || this.isBlockTemperatureHighLimitInvalid) {
            return null;
        }
        let stringIds = this.stringsList.filter(x => x.selected).map(x => x.value);
        if (!stringIds.length) {
            Notifier.onWarning("Select at least one String for the report!");
            return null;
        }
        let startDate = null;
        let endDate = null;
        let startTimezoneOffset = moment().utcOffset();
        let endTimezoneOffset = moment().utcOffset();
        if (this.chartData && this.chartData.labels.length > 0 &&
            (this.getHourFromDateItem(this.startEventDate) != this.getHourFromDateItem(this.chartData.labels[0]) ||
                this.getHourFromDateItem(this.endEventDate) != this.getHourFromDateItem(this.chartData.labels[this.chartData.labels.length - 1]))) {
            startDate = this.startEventDate;
            endDate = this.endEventDate;
            startTimezoneOffset = moment(startDate).utcOffset();
            endTimezoneOffset = moment(endDate).utcOffset();
        }
        var query = new GetDischargeDetailsQuery({
            currentTimezoneOffset: moment().utcOffset(),
            startTimezoneOffset: startTimezoneOffset,
            endTimezoneOffset: endTimezoneOffset,
            dischargeSnapshotId: (_b = (_a = this.selectedChargeCycleSnapshot) === null || _a === void 0 ? void 0 : _a.snapshotId) !== null && _b !== void 0 ? _b : 0,
            startTime: startDate,
            endTime: endDate,
            stringIds: stringIds,
            overrideLimits: this.overrideLimits,
            blockVoltageLowLimit: this.blockVoltageLowLimit,
            blockTemperatureHighLimit: this.blockTemperatureHighLimit
        });
        return query;
    }
    exportToPdf() {
        var query = this.getQuery();
        if (query == null)
            return;
        this.working = true;
        dischargesClient.downloadSystemDischargeAsPdf(query)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    // Watches
    onCompanyIdChanged() {
        var _a;
        var site = this.sites.find(site => site.siteId == this.siteId);
        if (this.companyId != (site === null || site === void 0 ? void 0 : site.companyId))
            this.siteId = null;
        if (((_a = this.system) === null || _a === void 0 ? void 0 : _a.companyId) != this.companyId)
            this.selectedSystem = new SystemAccessQueryModel();
    }
    onSiteIdChanged() {
        var _a;
        if (((_a = this.system) === null || _a === void 0 ? void 0 : _a.siteId) != this.siteId)
            this.selectedSystem = new SystemAccessQueryModel();
    }
    refreshSystemData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSystemInvalid)
                return;
            let promises = [
                this.getChargeCycleSnapshots()
            ];
            return yield Promise.all(promises).then();
        });
    }
    ;
    setDefaultDates() {
        return __awaiter(this, void 0, void 0, function* () {
            let dateRange = { start: this.startTime, end: this.endTime };
            switch (this.dateFilterOption) {
                case "Prev M":
                    dateRange = DateHelper.getDateRange(DatePresetOption.PrevMonth);
                    break;
                case "W":
                    dateRange = DateHelper.getDateRange(DatePresetOption.SevenDays);
                    break;
                case "M":
                    dateRange = DateHelper.getDateRange(DatePresetOption.OneMonth);
                    break;
                case "3M":
                    dateRange = DateHelper.getDateRange(DatePresetOption.ThreeMonths);
                    break;
                case "Y":
                    dateRange = DateHelper.getDateRange(DatePresetOption.OneYear);
                    break;
            }
            this.startTime = dateRange.start;
            this.endTime = dateRange.end;
            let areDatesValid = dateRange.start && dateRange.end && DateHelper.validateDateRange(dateRange.start, dateRange.end);
            if (!areDatesValid)
                return;
            if (this.chargeCycleSnapshotsQuery.pageNo != 1) {
                this.chargeCycleSnapshotsQuery.pageNo == 1;
                return;
            }
            return yield this.getChargeCycleSnapshots();
        });
    }
    ;
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSystemInvalid)
                return;
            this.chargeCycleSnapshotsQuery.sort = this.sorter.currentSort;
            return yield this.getChargeCycleSnapshots();
        });
    }
    ;
    onPageChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSystemInvalid)
                return;
            return yield this.getChargeCycleSnapshots();
        });
    }
    ;
    onCustomDatesSet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.showDatePickers)
                return;
            if (this.startDateInvalid || this.endDateInvalid || this.areDatesInvalid)
                return;
            if (this.chargeCycleSnapshotsQuery.pageNo != 1) {
                this.chargeCycleSnapshotsQuery.pageNo = 1;
                return;
            }
            return yield this.getChargeCycleSnapshots();
        });
    }
    ;
    onChargeCycleSnapshotChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.stringsList = new Array();
            this.eventsDateTimeList = new Array();
            if (!this.selectedChargeCycleSnapshot) {
                return;
            }
            this.working = true;
            var query = new GetChargeCycleEventsForSnapshotQuery({
                chargeCycleSnapshotId: this.selectedChargeCycleSnapshot.snapshotId
            });
            return yield eventsClient
                .getChargCycleEventsForSnapshot(query)
                .then(response => {
                // Create components list
                response.forEach(string => {
                    var stringItem = new SelectableListOption();
                    stringItem.value = string.stringId;
                    stringItem.text = string.componentName;
                    stringItem.selected = true;
                    this.stringsList.push(stringItem);
                });
                // Create events Date List
                this.chartData.labels = [];
                this.eventsDateTimeList = [];
                const seenEventTimes = new Set();
                response.forEach(string => {
                    var _a;
                    (_a = string.measurements) === null || _a === void 0 ? void 0 : _a.forEach(measurement => {
                        if (!measurement)
                            return;
                        // Use ISO string for uniqueness
                        const eventTimeKey = measurement.whenCreated instanceof Date
                            ? measurement.whenCreated.toISOString()
                            : new Date(measurement.whenCreated).toISOString();
                        if (!seenEventTimes.has(eventTimeKey)) {
                            seenEventTimes.add(eventTimeKey);
                            this.eventsDateTimeList.push(measurement.whenCreated);
                            this.chartData.labels.push(measurement.whenCreated);
                        }
                    });
                });
                // Chart Data
                this.chartData.datasets = [];
                response.forEach((string, idx) => {
                    var _a;
                    var dataset = {
                        data: [],
                        stringId: string.stringId,
                        label: string.componentName,
                        fill: false,
                        borderWidth: 1,
                        borderColor: this.getColour(idx),
                        lineTension: 0.15,
                        hidden: false
                    };
                    (_a = string.measurements) === null || _a === void 0 ? void 0 : _a.forEach(measurement => {
                        if (measurement != null) {
                            dataset.data.push(measurement.numericValue);
                        }
                    });
                    this.chartData.datasets.push(dataset);
                });
                this.eventsDateTimeList.sort((a, b) => {
                    return a.getTime() - b.getTime();
                });
                if (this.chartData.labels.length > 0) {
                    this.automaticDuration = true;
                    this.setDischargeDuration();
                }
                this.loadReportScheduleQuery(true, true);
                // Force to render the chart
                this.forceRerender();
                setTimeout(this.calculateGridHeight, 100);
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    setDuration() {
        if (this.automaticDuration) {
            this.setDischargeDuration();
        }
    }
    forceRerender() {
        this.componentKey += 1;
    }
    ;
    calculateGridHeight() {
        var secondColumnHeight = $('#second-column-parameters').height();
        $('#charge-cycle-table-inner-wrapper').height(Number(secondColumnHeight) - 123);
    }
    // computed
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.companyId || site.companyId == this.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteId = item.value;
    }
    ;
    get systemsFiltered() {
        var filteredSystems = this.systems
            .filter(system => (!this.companyId || system.companyId == this.companyId) && (!this.siteId || system.siteId == this.siteId));
        return filteredSystems;
    }
    get system() {
        return this.systems.filter(item => {
            var _a;
            return ((_a = this.selectedSystem) === null || _a === void 0 ? void 0 : _a.systemId) && item.systemId == this.selectedSystem.systemId;
        })[0];
    }
    ;
    set system(item) {
        this.selectedSystem = item;
    }
    ;
    get isSystemInvalid() {
        return (!this.selectedSystem || !this.selectedSystem.systemId) && this.searchAttempted;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    get areDatesInvalid() {
        if (!this.startTime || !this.endTime)
            return false;
        let startTime = DateHelper.convertToDate(this.startTime.toString());
        let endTime = DateHelper.convertToDate(this.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get isChargeCycleSnapshotInvalid() {
        return this.selectedChargeCycleSnapshot == null;
    }
    ;
    get isBlockVoltageLowLimitInvalid() {
        return this.overrideLimits && this.blockVoltageLowLimit == null && this.searchAttempted;
    }
    get isBlockTemperatureHighLimitInvalid() {
        return this.overrideLimits && this.blockTemperatureHighLimit == null && this.searchAttempted;
    }
    get selectPlaceholderSystem() {
        return "Please select a System";
    }
    ;
    get isChartAvailable() {
        return this.selectedChargeCycleSnapshot != null && this.chartData.datasets.length > 0;
    }
    get getTemperatureUoM() {
        return MeasurementHelper.getTemperatureLabel(this.useImperialMeasurementSystem);
    }
    getHourFromDateItem(item) {
        return moment(item).format('HH:mm:ss');
    }
    getColour(index) {
        let colours = [
            "#63b598", "#ce7d78", "#ea9e70", "#a48a9e", "#c6e1e8", "#648177", "#0d5ac1",
            "#f205e6", "#1c0365", "#14a9ad", "#4ca2f9", "#a4e43f", "#d298e2", "#6119d0",
            "#d2737d", "#c0a43c", "#f2510e", "#651be6", "#79806e"
        ];
        var colourIdx = index % 20;
        return colours[colourIdx];
    }
    selectDate(date) {
        if (this.automaticDuration)
            return;
        if (date < this.startEventDate) {
            this.startEventDate = date;
            this.isEnd = true;
        }
        else if (date > this.endEventDate || this.isEnd) {
            this.endEventDate = date;
            this.isEnd = false;
        }
        else {
            this.startEventDate = date;
            this.isEnd = true;
        }
        this.chartOptions.plugins.annotation.annotations[0].value = this.startEventDate;
        this.chartOptions.plugins.annotation.annotations[1].value = this.endEventDate;
        this.forceRerender();
    }
    isDateTimeSelected(date) {
        return this.startEventDate <= date && this.endEventDate >= date;
    }
    setDischargeDuration() {
        let firstItemIdx = 0, lastItemIdx = this.chartData.labels.length - 1;
        let length = this.chartData.datasets[0].data.length;
        const threshold = -3;
        if (this.chartData.datasets.length > 0) {
            for (let i = 0; i < this.chartData.labels.length; i++) {
                let found = false;
                for (let ds of this.chartData.datasets) {
                    if (ds.hidden)
                        continue;
                    const current = ds.data[i];
                    if (current < threshold) {
                        firstItemIdx = i;
                        found = true;
                        break;
                    }
                }
                if (found)
                    break;
            }
        }
        if (this.chartData.datasets.length > 0) {
            for (let i = this.chartData.labels.length - 1; i >= 0; i--) {
                let found = false;
                for (let ds of this.chartData.datasets) {
                    if (ds.hidden)
                        continue;
                    const current = ds.data[i];
                    if (current <= threshold) {
                        lastItemIdx = i;
                        found = true;
                        break;
                    }
                }
                if (found)
                    break;
            }
        }
        this.startEventDate = this.chartData.labels[firstItemIdx];
        this.endEventDate = this.chartData.labels[lastItemIdx];
        this.isEnd = false;
        this.isGraphClickEnd = false;
        this.chartOptions.plugins.annotation.annotations[0].value = this.startEventDate;
        this.chartOptions.plugins.annotation.annotations[1].value = this.endEventDate;
        this.forceRerender();
    }
    get numberOfSelectedString() {
        return this.stringsList.filter(x => x.selected).length;
    }
    ;
    onStringSelectionChanged() {
        if (!this.chartData || !this.chartData.datasets)
            return;
        this.stringsList.forEach(string => {
            //var dataset = this.chartData.datasets.filter(datasetItem => datasetItem.stringId == string.value);
            var dataset = this.chartData.datasets.find(function (datasetItem) {
                return datasetItem.stringId == string.value;
            });
            if (dataset) {
                dataset.hidden = !string.selected;
            }
        });
        if (this.automaticDuration)
            this.setDischargeDuration();
        this.forceRerender();
    }
    onCurrentChartClick(event, elements) {
        if (this.automaticDuration)
            return;
        const chart = event.chart;
        let points = chart.getElementsAtEventForMode(event, "nearest", {
            intersect: false
        });
        if (points && points.length > 0) {
            var index = points[0].index;
            this.setReportDurationFromGraphClick(index);
        }
    }
    setReportDurationFromGraphClick(index) {
        let date = this.chartData.labels[index];
        if (date < this.startEventDate) {
            this.startEventDate = date;
            this.isGraphClickEnd = true;
        }
        else if (date > this.endEventDate || this.isGraphClickEnd) {
            this.endEventDate = date;
            this.isGraphClickEnd = false;
        }
        else {
            this.startEventDate = date;
            this.isGraphClickEnd = true;
        }
        this.chartOptions.plugins.annotation.annotations[0].value = this.startEventDate;
        this.chartOptions.plugins.annotation.annotations[1].value = this.endEventDate;
        this.forceRerender();
    }
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var query = {
            systemId: this.system.systemId,
            automaticDuration: this.automaticDuration,
            displayChart: this.displayChart,
            startDateFilter: this.startTime,
            endDateFilter: this.endTime,
            reportQuery: reportQuery
        };
        var queryString = JSON.stringify(query);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    onReportScheduledModelChanged() {
        this.reportScheduleQueryLoaded = false;
        this.loadReportScheduleQuery(false, false);
    }
    loadReportScheduleQuery(snapshotsLoaded = false, stringsLoaded = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (this.reportScheduleQueryLoaded)
            return;
        if (!((_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query))
            return;
        var queryString = (_b = this.reportScheduledModel) === null || _b === void 0 ? void 0 : _b.query;
        try {
            var query = JSON.parse(queryString);
            var reportQuery = query.reportQuery;
            if (!snapshotsLoaded) {
                this.setDateFilterOption("...");
                this.startTime = query.startDateFilter ? DateHelper.convertToDate(query.startDateFilter) : null;
                this.endTime = query.endDateFilter ? DateHelper.convertToDate(query.endDateFilter) : null;
                var system = (_c = this.systems.find(item => item.systemId == query.systemId)) !== null && _c !== void 0 ? _c : new SystemAccessQueryModel();
                this.companyId = (_d = system === null || system === void 0 ? void 0 : system.companyId) !== null && _d !== void 0 ? _d : null;
                this.siteId = (_e = system === null || system === void 0 ? void 0 : system.siteId) !== null && _e !== void 0 ? _e : null;
                this.system = system;
                this.overrideLimits = reportQuery.overrideLimits;
                this.blockVoltageLowLimit = reportQuery.blockVoltageLowLimit;
                this.blockTemperatureHighLimit = reportQuery.blockTemperatureHighLimit;
            }
            else if (!stringsLoaded) {
                this.selectedChargeCycleSnapshot = (_h = (_g = (_f = this.chargeCycleSnapshots) === null || _f === void 0 ? void 0 : _f.records) === null || _g === void 0 ? void 0 : _g.find(item => item.snapshotId == reportQuery.dischargeSnapshotId)) !== null && _h !== void 0 ? _h : null;
                if (this.selectedChargeCycleSnapshot == null && ((_j = this.chargeCycleSnapshots.records) === null || _j === void 0 ? void 0 : _j.length) > 0) {
                    this.working = false;
                    this.chargeCycleSnapshotsQuery.pageNo++;
                    return;
                }
            }
            else {
                this.stringsList.forEach(item => item.selected = reportQuery.stringIds.indexOf(item.value) >= 0);
                this.automaticDuration = query.automaticDuration;
                this.displayChart = query.displayChart;
                this.startEventDate = DateHelper.convertToDate(reportQuery.startTime);
                this.endEventDate = DateHelper.convertToDate(reportQuery.endTime);
                this.chartOptions.plugins.annotation.annotations[0].value = this.startEventDate;
                this.chartOptions.plugins.annotation.annotations[1].value = this.endEventDate;
                this.forceRerender();
                this.reportScheduleQueryLoaded = true;
            }
        }
        catch (ex) {
            console.error(ex);
        }
    }
    getPeriodTitle(item) {
        return DateHelper.getDateFilterOptionTitle(item);
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], DischargeReportFilterVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _b : Object)
], DischargeReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeReportFilterVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeReportFilterVue.prototype, "onSiteIdChanged", null);
__decorate([
    Watch("selectedSystem"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], DischargeReportFilterVue.prototype, "refreshSystemData", null);
__decorate([
    Watch("dateFilterOption"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], DischargeReportFilterVue.prototype, "setDefaultDates", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], DischargeReportFilterVue.prototype, "onSortChanged", null);
__decorate([
    Watch("chargeCycleSnapshotsQuery.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], DischargeReportFilterVue.prototype, "onPageChanged", null);
__decorate([
    Watch("startTime"),
    Watch("endTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], DischargeReportFilterVue.prototype, "onCustomDatesSet", null);
__decorate([
    Watch("selectedChargeCycleSnapshot"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], DischargeReportFilterVue.prototype, "onChargeCycleSnapshotChanged", null);
__decorate([
    Watch("automaticDuration"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeReportFilterVue.prototype, "setDuration", null);
__decorate([
    Watch("numberOfSelectedString"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeReportFilterVue.prototype, "onStringSelectionChanged", null);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DischargeReportFilterVue.prototype, "onReportScheduledModelChanged", null);
DischargeReportFilterVue = __decorate([
    Component({
        name: "DischargeReportFilterVue",
        components: {
            DischargeReportFilterGraphVue,
            Toggle
        },
        emits: ["schedule", "updateSchedule"]
    })
], DischargeReportFilterVue);
export default DischargeReportFilterVue;
